import { UtilityService } from '../../services/utility.service';
import { ConnectedDevice } from './connected-device.model';
import { ControllerProgrammability } from './programmability-ux/controller-programmability.model';

export class ToroController extends ConnectedDevice
{
    constructor(json: object = null)
    {
        super();

        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    public CommCard: any;
    public Description: string;
    public Id: number;
    public ImageAssetId?: number = null;
    public IsProgrammable: boolean;
    public IsRecognized: boolean;
    public IsControllerSupported = false;
    public ManualRunTimePerStation: number;
    public Name: string;
    public ParentId: number;
    public Programmability: ControllerProgrammability;
    public ProgramsHeaderText: string;
    public ProgramLabelText: string;
    public RunningMode: number;
    public RunningModeMaxIntervalDays = 14;
    public RunningModeRestartInDays: number;
    public StaticWebImageFilename: number;
    public StationsHeaderText: string;
    public StationLabelText: string;
    public TestProgramDuration = 3;

}
